import React from 'react'
import CoinMarket from '../Home/CoinMarket'
import { Typography, Box, Button } from '@mui/material'
import ListStock from '../Stock/ListStock'
import TabPanel from '@mui/lab/TabPanel';

import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';

const StartTrading = () => {

  const [value, setValue] = React.useState('Stocks');
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div style={{marginTop: '75px'}}>
        <Typography   ml={3} mt={4} sx={{ fontWeight: 'bold', fontSize: 20, textTransform: 'uppercase', textAlign: 'center'  }} gutterBottom variant="h6" component="div">
                TRADE SUPPORTED ASSETS
        </Typography>
        <Typography  sx={{textAlign: 'center'}} variant="body2" color="text.secondary">
                kindly click any asset pair to trade
        </Typography>
        

        <Box sx={{ width: '100%', marginTop: '10px', typography: 'body1' }}>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleChange} aria-label="Trade table" 
              variant="scrollable"
              gap={1}
              scrollButtons={true}
              >
                <Tab sx={{paddingRight: '1px'}} label={<Button size='small' sx={{width: '170px', marginRight: '5px', bgcolor: '#1c1c1b', color: '#fff'}} variant="contained">Stocks</Button>} value="Stocks" />            
                <Tab sx={{paddingLeft: 0}} label={<Button size='small' sx={{width: '170px', marginLeft: '5px', bgcolor: '#383838', color: '#fff'}} variant="contained">Crypto</Button>} value="Crypto" />
                
              </TabList>
            </Box>

            <TabPanel sx={{width: '100%', marginX: 0,  padding: '2px'}} value="Stocks"><ListStock/></TabPanel>
            <TabPanel sx={{width: '100%', marginX: 0, padding: '2px'}} value="Crypto"><CoinMarket/></TabPanel>
            
          </TabContext>
        </Box>
      
    </div>
  )
}

export default StartTrading
